const generator = require('./providercredit-fullcont-multitable-generator')
const timeDate         = require ('../../../../../js-handler/time-date')



export function start(detail){  //console.log('gmt>', detail)
         
      obj[detail.act].start(detail)
}/**/


const obj = {
   
      add: { start: (detail)=>{ add(detail) }},
}

export const providercreditMT = [

	{
		tableName: "providercredit_vs_credited_purchase", 
		value:'', 
		id:'providercredit_form_providercredit_vs_credited_purchase',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name:      'purchase_id', 
				type:      'autocomplete',
				html:      '',
				required:  true,  
			},
			{
				name:      'po_total_amount', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
			{
				name:      'available_credit', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
			{
				name:      'used_credit', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},

		],

		generator: function(line){ 
			return generator.providercredit_vs_credited_purchase(line.id) 
		},

		add: function(){ 
			const newLine = generator.providercredit_vs_credited_purchase('')
			this.html.insertAdjacentHTML("beforeend", newLine) 

		} 
	},

	{
		tableName: "providercredit_vs_paid_purchase", 
		value:'', 
		id:'providercredit_form_providercredit_vs_paid_purchase',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name:      'purchase_id', 
				type:      'autocomplete',
				html:      '',
				required:  true,  
			},
			{
				name:      'po_total_amount', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
			{
				name:      'due_amount', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
			{
				name:      'sent_amount', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
		],

		generator: function(line){ 
			return generator.providercredit_vs_paid_purchase(line.id) 
		},

		add: function(){ 
			const newLine = generator.providercredit_vs_paid_purchase('')
			//console.log("newline", newLine);
			this.html.insertAdjacentHTML("beforeend", newLine) 
		} 
	}


]